export class PaymentVO {
  customerName: string;
  email: string;
  phoneNumber: string;
  amount: string;
  transactionId:string;
}
